// Quick add for product cards (snippets/nw-card-add.liquid): adds to the cart over AJAX,
// keeps the shopper on the page and refreshes the theme's cart count / drawer.
(() => {
  if (window.nwCardAdd) return;
  window.nwCardAdd = true;

  document.addEventListener('click', (event) => {
    const step = event.target.closest('.nw-add__step');
    if (!step) return;
    const input = step.parentElement.querySelector('input[name="quantity"]');
    const inc = Number(input.step) || 1;
    const min = Number(input.min) || 1;
    const max = input.max ? Number(input.max) : Infinity;
    const next = (Number(input.value) || min) + inc * Number(step.dataset.step);
    input.value = Math.min(max, Math.max(min, next));
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-nw-add]');
    if (!form) return;
    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const label = button.querySelector('.nw-add__label');
    const msg = form.parentElement.querySelector('.nw-add__msg');
    if (button.getAttribute('aria-disabled') === 'true') return;
    button.setAttribute('aria-disabled', 'true');
    label.textContent = 'Adding…';
    if (msg) msg.hidden = true;

    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add to basket');

      const cart = await (await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } })).json();
      if (window.FoxTheme?.pubsub) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: false } }));

      label.textContent = '✓ Added';
      button.classList.add('nw-add__btn--done');
      setTimeout(() => {
        label.textContent = 'Add';
        button.classList.remove('nw-add__btn--done');
      }, 1800);
    } catch (error) {
      label.textContent = 'Add';
      if (msg) {
        msg.textContent = error.message;
        msg.hidden = false;
      }
    } finally {
      button.removeAttribute('aria-disabled');
    }
  });
})();
